import { TComputedPropMapper } from '../../../types/computed-props-mapper';

export const isFromSuburbanBuilder: TComputedPropMapper<boolean> = ({ offer: { dealType, kp, offerType, isResale } }) =>
  dealType === 'sale' && offerType === 'suburban' && Boolean(kp) && !isResale;
